import * as $ from 'jquery'

if (typeof $.magnificPopup !== 'undefined') {

  $('.gallery').each(function() {
    $(this).magnificPopup({
      delegate: 'a',
      type: 'image',
      image: {
        titleSrc: function(item) {
          return $(item.el).closest('.gallery-item').find('.gallery-caption').text()
        }
      },
      gallery: {
        enabled: true
      }
    })
  })

  $('.video-gallery').magnificPopup({
    delegate: 'a[href*="youtube.com"]',
    type: 'iframe',
    gallery: {
      enabled: true
    }
  })

}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/init-lightbox.js